import { render } from "./BadgeState.vue?vue&type=template&id=522447c0&scoped=true&ts=true"
import script from "./BadgeState.vue?vue&type=script&lang=ts"
export * from "./BadgeState.vue?vue&type=script&lang=ts"

import "./BadgeState.vue?vue&type=style&index=0&id=522447c0&lang=scss&scoped=true"
import "./BadgeState.vue?vue&type=style&index=1&id=522447c0&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-522447c0"]])

export default __exports__